export default __webpack_public_path__ + "media/images/dashboard_icons/hotels-6d6f0f860c048dc1f73de7507ca63869.svg";